/**
 * @file Purchase album start container.
 */

import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import PurchaseAlbumStart from '../../../components/purchase/start/PurchaseAlbumStart';
import { AlbumDataWithParentAndSubscription } from '../../../graphql/queries/albums';

const withAlbum = graphql(AlbumDataWithParentAndSubscription, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { loading, album } }) => ({
    loading,
    album,
  }),
});

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(
  withRouter,
  withAlbum,
  connect(mapStateToProps, null),
)(PurchaseAlbumStart);
